import { createContext } from 'react';

export const DevToolsContext = createContext({});
